import { useNavigate, useLocation } from "react-router-dom";
import Received from "../../../assets/aftersalesservice_icons/received_icon.png";
import Success from "../../../assets/aftersalesservice_icons/success_icon.png";
import FallbackImg from "../../../components/FallbackImg";
import { useLanguage } from "../LanguageContext";
import { getCustomerServicePhone } from "../warrantyPhoneUtils";

const RegisteredReceived = ({
  isNewInstall = false,
  serialQuery = "",
  isRepairCompleted = false,
  isRepairRevisit = false,
  isLocal = false,
}) => {
  const { trans, countryCode } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const csPhone = getCustomerServicePhone(countryCode);

  const handleGoBack = () => {
    if (
      location.pathname === "/aftersalesservice/newinstallation" ||
      location.pathname === "/aftersalesservice/registerserialno" ||
      location.pathname === "/aftersalesservice/registerserialnobrunei" ||
      location.pathname === "/aftersalesservice/registerserialnosingle"
    ) {
      navigate(`/aftersalesservice${serialQuery}`);
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="as-csn_success-wrapper" id="register_received_modal">
      <div className="as-csn_success-card">
        {/* Top blue section */}
        <div className="as-csn_success-top">
          <div className="as-csn_success-icon">
            <div className="as-csn_success-icon-inner">
              {isNewInstall || isLocal ? (
                <FallbackImg
                  src={Success}
                  alt="success"
                  style={{ marginTop: 35, width: 172, height: 186 }}
                />
              ) : (
                <FallbackImg
                  src={Received}
                  alt="received"
                  style={{ marginTop: 35 }}
                />
              )}
            </div>
          </div>
          <div className="as-csn_success-title">{trans.reg_received}</div>
          <div className="as-csn_success-sub">
            {isNewInstall
              ? trans.reg_received_sub_newinstall
              : isRepairRevisit
                ? trans.reg_received_sub_repairrevisit
                : isRepairCompleted
                  ? trans.reg_received_sub_repaircompleted
                  : trans.reg_received_sub}
          </div>
        </div>

        {/* White bottom section */}
        <div className="as-csn_success-bottom">
          <div className="as-csn_qr-card-yellow">
            <div className="as-csn_qr-text-sub" style={{ marginBottom: 20 }}>
              {isNewInstall
                ? trans.our_cust_newinstall
                : isRepairRevisit
                  ? trans.our_cust_repairrevisit
                  : isRepairCompleted
                    ? trans.our_cust_repaircompleted
                    : trans.our_cust}
            </div>
            <div className="as-csn_qr-text-sub">
              {isNewInstall || isRepairRevisit || isRepairCompleted || isLocal
                ? trans.need_update_newinstall
                : trans.need_update}
              <span>{csPhone.display}</span>
            </div>
          </div>

          <button
            type="button"
            className="as-csn_primary-btn"
            id="reg_success_close"
            onClick={handleGoBack}
          >
            {trans.got_it}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisteredReceived;
